import React from "react";
import { Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { injectModels } from "../../../redux/injectModels";
import { Link } from "react-router-dom";
import { routes } from "../../../constants/routes";
import ReactPaginate from "react-paginate";
import { AuthService } from "../../../services";
import Swal from "sweetalert2";
import { globalConstant } from "../../../constants/globalConstant";
import { handleConsoleError } from "../../../utils/common-methods";

function UserManagement(props) {
  const [currentPage, setCurrentPage] = useState(0);
  // const [showPreviousButton, setShowPreviousButton] = useState(false);
  // const [showNextButton, setShowNextButton] = useState(true);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    props.application.setLoading(true);

    try {
      const res = await AuthService.getApproveRejectUsers();
      if (res?.isSuccess && res?.data?.length > 0) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        setFilteredData([]);
        props.application.setLoading(false);
      }
    } catch (error) {
      setFilteredData([]);
      props.application.setLoading(false);
    }
  };

  const handleApprove = async (id, isApprove) => {
    try {
      let message = isApprove ? "approve" : "reject";

      const pinkColor = globalConstant.COLOR_PINK;
      Swal.fire({
        title: "Confirmation",
        text: `Are you sure you want to ${message} user account?`,
        showCancelButton: true,
        confirmButtonColor: pinkColor,
        cancelButtonColor: "#373737",
        confirmButtonText: `Yes`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          // if (isApprove) {
          props.application.setLoading(true);
          const res = await AuthService.approveRejectUser({
            id,
            isApproved: isApprove,
          });
      
          if (res?.isSuccess) {
            await fetchData();
            toast.success(res?.message);
            props.application.setLoading(false);
          } else {
            toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
            props.application.setLoading(false);
          }
        }
      });
    } catch (error) {
      const message=handleConsoleError(error)
      toast.error(error?.message || message);
      props.application.setLoading(false);
    }

    // props.application.setLoading(true);
  };

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  // const handlePageChange = ({ selected }) => {
  //   setCurrentPage(selected);

  //   if (selected === 0) {
  //     setShowPreviousButton(false);
  //   } else {
  //     setShowPreviousButton(true);
  //   }

  //   const pageCount = Math.ceil(filteredData.length / rowsPerPage);

  //   if (filteredData.length === 0) {
  //     setShowNextButton(false);
  //   } else if (selected === pageCount - 1) {
  //     setShowNextButton(false);
  //   } else {
  //     setShowNextButton(true);
  //   }
  // };

  const handlePageChange = ({ selected }) => setCurrentPage(selected);

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  return (
    <React.Fragment>
      <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            {/* <li className="breadcrumb-item">Content Management</li>*/}
            <li className="breadcrumb-item active">Manage New Users</li>
          </ol>
        </nav>
      </div>
      <div className="table-responsive">
        <div>
          <h2>Manage New Users</h2>
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData && paginatedData.length > 0 ? (
              <React.Fragment>
                {paginatedData.map((item, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{calculateSNo(idx)}</td>
                      <td>{item?.firstName + " " + item?.lastName}</td>
                      <td>{item?.email}</td>

                      <td>{item.role}</td>
                      <td>
                        <div className="delete-create">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              handleApprove(item?.id, true);
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <i
                              className="fa-solid fa-circle-check"
                              title="Approve"
                            ></i>
                          </Link>

                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              handleApprove(item?.id, false);
                            }}
                          >
                            <i
                              className="fa-solid fa-circle-xmark"
                              // style={{ color: "#F06548" }}
                              title="Reject"
                            ></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="10 mt-2">No results found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="table-footer">
        <p className="mb-3">
          <strong>Total Count: {filteredData.length}</strong>
        </p>
        {filteredData.length === 0 ? "" : renderPagination()}
      </div>
    </React.Fragment>
  );
}

export default injectModels(["admin", "application"])(UserManagement);
